import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import IndexLayout from 'layouts/IndexLayout';
import MainLayout from 'layouts/MainLayout';
import AuthRoutes from 'components/AuthRoutes';
import IndexPage from 'pages/index/IndexPage';
import AuditlogList from 'pages/auditlog/List';
import AuditlogView from 'pages/auditlog/View';
import AuditlogAdd from 'pages/auditlog/Add';
import AuditlogEdit from 'pages/auditlog/Edit';
import BillsummaryvwList from 'pages/billsummaryvw/List';
import BillsummaryvwPartner from 'pages/billsummaryvw/Partner';
import BookingpartnervwList from 'pages/bookingpartnervw/List';
import BookingpromotionsList from 'pages/bookingpromotions/List';
import BookingpromotionsView from 'pages/bookingpromotions/View';
import BookingpromotionsAdd from 'pages/bookingpromotions/Add';
import BookingpromotionsEdit from 'pages/bookingpromotions/Edit';
import BookingsList from 'pages/bookings/List';
import BookingsView from 'pages/bookings/View';
import BookingsAdd from 'pages/bookings/Add';
import BookingsEdit from 'pages/bookings/Edit';
import BookingsListcustomer from 'pages/bookings/Listcustomer';
import BookingstatushistoryList from 'pages/bookingstatushistory/List';
import BookingstatushistoryView from 'pages/bookingstatushistory/View';
import BookingstatushistoryAdd from 'pages/bookingstatushistory/Add';
import BookingstatushistoryEdit from 'pages/bookingstatushistory/Edit';
import CategoryList from 'pages/category/List';
import CategoryView from 'pages/category/View';
import CategoryAdd from 'pages/category/Add';
import CategoryEdit from 'pages/category/Edit';
import ChatmessagesList from 'pages/chatmessages/List';
import ChatmessagesView from 'pages/chatmessages/View';
import ChatmessagesAdd from 'pages/chatmessages/Add';
import ChatmessagesEdit from 'pages/chatmessages/Edit';
import CitiesList from 'pages/cities/List';
import CitiesView from 'pages/cities/View';
import CitiesAdd from 'pages/cities/Add';
import CitiesEdit from 'pages/cities/Edit';
import ConsentsList from 'pages/consents/List';
import ConsentsView from 'pages/consents/View';
import ConsentsAdd from 'pages/consents/Add';
import ConsentsEdit from 'pages/consents/Edit';
import ContactsList from 'pages/contacts/List';
import ContactsView from 'pages/contacts/View';
import ContactsAdd from 'pages/contacts/Add';
import ContactsEdit from 'pages/contacts/Edit';
import CustomernotificationsList from 'pages/customernotifications/List';
import CustomernotificationsView from 'pages/customernotifications/View';
import CustomernotificationsAdd from 'pages/customernotifications/Add';
import CustomernotificationsEdit from 'pages/customernotifications/Edit';
import CustomernotificationsNotify from 'pages/customernotifications/Notify';
import InventoryList from 'pages/inventory/List';
import InventoryView from 'pages/inventory/View';
import InventoryAdd from 'pages/inventory/Add';
import InventoryEdit from 'pages/inventory/Edit';
import ItemtypesList from 'pages/itemtypes/List';
import ItemtypesView from 'pages/itemtypes/View';
import ItemtypesAdd from 'pages/itemtypes/Add';
import ItemtypesEdit from 'pages/itemtypes/Edit';
import ItemtypetreatmentsList from 'pages/itemtypetreatments/List';
import ItemtypetreatmentsView from 'pages/itemtypetreatments/View';
import ItemtypetreatmentsAdd from 'pages/itemtypetreatments/Add';
import ItemtypetreatmentsEdit from 'pages/itemtypetreatments/Edit';
import ItemtypetreatmentsTreatementpartner from 'pages/itemtypetreatments/TreatementPartner';
import NotificationsList from 'pages/notifications/List';
import NotificationsView from 'pages/notifications/View';
import NotificationsAdd from 'pages/notifications/Add';
import NotificationsEdit from 'pages/notifications/Edit';
import OrderitemsList from 'pages/orderitems/List';
import OrderitemsView from 'pages/orderitems/View';
import OrderitemsAdd from 'pages/orderitems/Add';
import OrderitemsEdit from 'pages/orderitems/Edit';
import OrderitemsListordcustomer from 'pages/orderitems/Listordcustomer';
import PartnerdocumentsList from 'pages/partnerdocuments/List';
import PartnerdocumentsView from 'pages/partnerdocuments/View';
import PartnerdocumentsAdd from 'pages/partnerdocuments/Add';
import PartnerdocumentsEdit from 'pages/partnerdocuments/Edit';
import PartnernotificationsList from 'pages/partnernotifications/List';
import PartnernotificationsView from 'pages/partnernotifications/View';
import PartnernotificationsAdd from 'pages/partnernotifications/Add';
import PartnernotificationsEdit from 'pages/partnernotifications/Edit';
import PartnerpaymentsList from 'pages/partnerpayments/List';
import PartnerpaymentsView from 'pages/partnerpayments/View';
import PartnerpaymentsAdd from 'pages/partnerpayments/Add';
import PartnerpaymentsEdit from 'pages/partnerpayments/Edit';
import PartnerpaymentvwList from 'pages/partnerpaymentvw/List';
import PartnerperformanceList from 'pages/partnerperformance/List';
import PartnerperformanceView from 'pages/partnerperformance/View';
import PartnerperformanceAdd from 'pages/partnerperformance/Add';
import PartnerperformanceEdit from 'pages/partnerperformance/Edit';
import PartnerreviewsList from 'pages/partnerreviews/List';
import PartnerreviewsView from 'pages/partnerreviews/View';
import PartnerreviewsAdd from 'pages/partnerreviews/Add';
import PartnerreviewsEdit from 'pages/partnerreviews/Edit';
import PartnershopsList from 'pages/partnershops/List';
import PartnershopsView from 'pages/partnershops/View';
import PartnershopsAdd from 'pages/partnershops/Add';
import PartnershopsEdit from 'pages/partnershops/Edit';
import PartnershopsPartner from 'pages/partnershops/Partner';
import PaymentsList from 'pages/payments/List';
import PaymentsView from 'pages/payments/View';
import PaymentsAdd from 'pages/payments/Add';
import PaymentsEdit from 'pages/payments/Edit';
import PaymentsPaymentcustomer from 'pages/payments/Paymentcustomer';
import PermissionsList from 'pages/permissions/List';
import PermissionsView from 'pages/permissions/View';
import PermissionsAdd from 'pages/permissions/Add';
import PermissionsEdit from 'pages/permissions/Edit';
import PromotionsList from 'pages/promotions/List';
import PromotionsView from 'pages/promotions/View';
import PromotionsAdd from 'pages/promotions/Add';
import PromotionsEdit from 'pages/promotions/Edit';
import RolesList from 'pages/roles/List';
import RolesView from 'pages/roles/View';
import RolesAdd from 'pages/roles/Add';
import RolesEdit from 'pages/roles/Edit';
import ServicepricesList from 'pages/serviceprices/List';
import ServicepricesView from 'pages/serviceprices/View';
import ServicepricesAdd from 'pages/serviceprices/Add';
import ServicepricesEdit from 'pages/serviceprices/Edit';
import ServicesList from 'pages/services/List';
import ServicesView from 'pages/services/View';
import ServicesAdd from 'pages/services/Add';
import ServicesEdit from 'pages/services/Edit';
import SettingsList from 'pages/settings/List';
import SettingsView from 'pages/settings/View';
import SettingsAdd from 'pages/settings/Add';
import SettingsEdit from 'pages/settings/Edit';
import StaffList from 'pages/staff/List';
import StaffView from 'pages/staff/View';
import StaffAdd from 'pages/staff/Add';
import StaffEdit from 'pages/staff/Edit';
import StaffPartner from 'pages/staff/Partner';
import StaffassignmentsList from 'pages/staffassignments/List';
import StaffassignmentsView from 'pages/staffassignments/View';
import StaffassignmentsAdd from 'pages/staffassignments/Add';
import StaffassignmentsEdit from 'pages/staffassignments/Edit';
import StaffassingmentvwList from 'pages/staffassingmentvw/List';
import StaffvwList from 'pages/staffvw/List';
import StaffvwView from 'pages/staffvw/View';
import StatesList from 'pages/states/List';
import StatesView from 'pages/states/View';
import StatesAdd from 'pages/states/Add';
import StatesEdit from 'pages/states/Edit';
import TreatmentsList from 'pages/treatments/List';
import TreatmentsView from 'pages/treatments/View';
import TreatmentsAdd from 'pages/treatments/Add';
import TreatmentsEdit from 'pages/treatments/Edit';
import UsersList from 'pages/users/List';
import UsersView from 'pages/users/View';
import UsersAdd from 'pages/users/Add';
import UsersEdit from 'pages/users/Edit';
import UsersPartnerreister from 'pages/users/Partnerreister';
import VwactivebookingsList from 'pages/vwactivebookings/List';
import VwcustomerlifetimevalueList from 'pages/vwcustomerlifetimevalue/List';
import VwdailybookingsummaryList from 'pages/vwdailybookingsummary/List';
import VwinventorystatusList from 'pages/vwinventorystatus/List';
import VwmonthlyperformanceList from 'pages/vwmonthlyperformance/List';
import VwpendingpaymentsList from 'pages/vwpendingpayments/List';
import VwserviceperformanceList from 'pages/vwserviceperformance/List';
import VwstaffperformanceList from 'pages/vwstaffperformance/List';
import WallettransactionList from 'pages/wallettransaction/List';
import WallettransactionView from 'pages/wallettransaction/View';
import WallettransactionAdd from 'pages/wallettransaction/Add';
import WallettransactionEdit from 'pages/wallettransaction/Edit';
import WallettransactionPartnerwallet from 'pages/wallettransaction/PartnerWallet';
import WalletvwList from 'pages/walletvw/List';
import WebhooklogsList from 'pages/webhooklogs/List';
import WebhooklogsView from 'pages/webhooklogs/View';
import WebhooklogsAdd from 'pages/webhooklogs/Add';
import WebhooklogsEdit from 'pages/webhooklogs/Edit';
import QuickbookingwidgetPage from 'pages/custom/QuickbookingwidgetPage';
import BookingquickPage from 'pages/custom/BookingquickPage';
import CustomerPage from 'pages/home/CustomerPage';
import StaffPage from 'pages/home/StaffPage';
import PartnerPage from 'pages/home/PartnerPage';
import PaymentduePage from 'pages/custom/PaymentduePage';
import AdditemsPage from 'pages/custom/AdditemsPage';
import BcalenderPage from 'pages/custom/BcalenderPage';
import StaffcalendarPage from 'pages/custom/StaffcalendarPage';
import PrintinvoicePage from 'pages/custom/PrintinvoicePage';
import CustomerreviewPage from 'pages/custom/CustomerreviewPage';
import TopupwalletPage from 'pages/custom/TopupwalletPage';
import WhatsappchatPage from 'pages/custom/WhatsappchatPage';
import AdditionalItemPage from 'pages/custom/AdditionalItemPage';
import PricecomparePage from 'pages/custom/PricecomparePage';
import ConsentPage from 'pages/custom/ConsentPage';
import AccountPages from 'pages/account';
import HomePage from './pages/home/HomePage';
import IndexPages from './pages/index';
import ErrorPages from './pages/errors';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'assets/styles/layout.scss';

import  TopupSuccess from 'pages/topup/TopupSuccess';
import OrderStatusFlow from 'pages/custom/OrderStatusFlow';

const App = () => {
	const auth = useAuth();
	function DefaultPage(){
		if(!auth.isLoggedIn){
			return <IndexPage />
		}
		return <Navigate to="/home" replace />;
	}
	function UserRoleHomePage(){
		const userRole = (auth.userRole || '').toLowerCase();
		switch(userRole){
			case 'customer':
				return <CustomerPage />
			case 'staff':
				return <StaffPage />
			case 'partner':
				return <PartnerPage />
			default:
				return <HomePage />;
		}
	}
	return (
		<Routes>
			<Route exact element={<AuthRoutes />}>
			<Route element={<MainLayout />}>
				<Route path="/home" element={<UserRoleHomePage />} />
				

				{/* auditlog pages routes */}
				<Route path="/auditlog" element={<AuditlogList />} />
				<Route path="/auditlog/:fieldName/:fieldValue" element={<AuditlogList />} />
				<Route path="/auditlog/index/:fieldName/:fieldValue" element={<AuditlogList />} />
				<Route path="/auditlog/view/:pageid" element={<AuditlogView />} />
				<Route path="/auditlog/add" element={<AuditlogAdd />} />
				<Route path="/auditlog/edit/:pageid" element={<AuditlogEdit />} />

				{/* billsummaryvw pages routes */}
				<Route path="/billsummaryvw" element={<BillsummaryvwList />} />
				<Route path="/billsummaryvw/:fieldName/:fieldValue" element={<BillsummaryvwList />} />
				<Route path="/billsummaryvw/index/:fieldName/:fieldValue" element={<BillsummaryvwList />} />
				<Route path="/billsummaryvw/partner" element={<BillsummaryvwPartner />} />
				<Route path="/billsummaryvw/partner/:fieldName/:fieldValue" element={<BillsummaryvwPartner />} />

				{/* bookingpartnervw pages routes */}
				<Route path="/bookingpartnervw" element={<BookingpartnervwList />} />
				<Route path="/bookingpartnervw/:fieldName/:fieldValue" element={<BookingpartnervwList />} />
				<Route path="/bookingpartnervw/index/:fieldName/:fieldValue" element={<BookingpartnervwList />} />

				{/* bookingpromotions pages routes */}
				<Route path="/bookingpromotions" element={<BookingpromotionsList />} />
				<Route path="/bookingpromotions/:fieldName/:fieldValue" element={<BookingpromotionsList />} />
				<Route path="/bookingpromotions/index/:fieldName/:fieldValue" element={<BookingpromotionsList />} />
				<Route path="/bookingpromotions/view/:pageid" element={<BookingpromotionsView />} />
				<Route path="/bookingpromotions/add" element={<BookingpromotionsAdd />} />
				<Route path="/bookingpromotions/edit/:pageid" element={<BookingpromotionsEdit />} />

				{/* bookings pages routes */}
				<Route path="/bookings" element={<BookingsList />} />
				<Route path="/bookings/:fieldName/:fieldValue" element={<BookingsList />} />
				<Route path="/bookings/index/:fieldName/:fieldValue" element={<BookingsList />} />
				<Route path="/bookings/view/:pageid" element={<BookingsView />} />
				<Route path="/bookings/add" element={<BookingsAdd />} />
				<Route path="/bookings/edit/:pageid" element={<BookingsEdit />} />
				<Route path="/bookings/listcustomer" element={<BookingsListcustomer />} />
				<Route path="/bookings/listcustomer/:fieldName/:fieldValue" element={<BookingsListcustomer />} />

				{/* bookingstatushistory pages routes */}
				<Route path="/bookingstatushistory" element={<BookingstatushistoryList />} />
				<Route path="/bookingstatushistory/:fieldName/:fieldValue" element={<BookingstatushistoryList />} />
				<Route path="/bookingstatushistory/index/:fieldName/:fieldValue" element={<BookingstatushistoryList />} />
				<Route path="/bookingstatushistory/view/:pageid" element={<BookingstatushistoryView />} />
				<Route path="/bookingstatushistory/add" element={<BookingstatushistoryAdd />} />
				<Route path="/bookingstatushistory/edit/:pageid" element={<BookingstatushistoryEdit />} />

				{/* category pages routes */}
				<Route path="/category" element={<CategoryList />} />
				<Route path="/category/:fieldName/:fieldValue" element={<CategoryList />} />
				<Route path="/category/index/:fieldName/:fieldValue" element={<CategoryList />} />
				<Route path="/category/view/:pageid" element={<CategoryView />} />
				<Route path="/category/add" element={<CategoryAdd />} />
				<Route path="/category/edit/:pageid" element={<CategoryEdit />} />

				{/* chatmessages pages routes */}
				<Route path="/chatmessages" element={<ChatmessagesList />} />
				<Route path="/chatmessages/:fieldName/:fieldValue" element={<ChatmessagesList />} />
				<Route path="/chatmessages/index/:fieldName/:fieldValue" element={<ChatmessagesList />} />
				<Route path="/chatmessages/view/:pageid" element={<ChatmessagesView />} />
				<Route path="/chatmessages/add" element={<ChatmessagesAdd />} />
				<Route path="/chatmessages/edit/:pageid" element={<ChatmessagesEdit />} />

				{/* cities pages routes */}
				<Route path="/cities" element={<CitiesList />} />
				<Route path="/cities/:fieldName/:fieldValue" element={<CitiesList />} />
				<Route path="/cities/index/:fieldName/:fieldValue" element={<CitiesList />} />
				<Route path="/cities/view/:pageid" element={<CitiesView />} />
				<Route path="/cities/add" element={<CitiesAdd />} />
				<Route path="/cities/edit/:pageid" element={<CitiesEdit />} />

				{/* consents pages routes */}
				<Route path="/consents" element={<ConsentsList />} />
				<Route path="/consents/:fieldName/:fieldValue" element={<ConsentsList />} />
				<Route path="/consents/index/:fieldName/:fieldValue" element={<ConsentsList />} />
				<Route path="/consents/view/:pageid" element={<ConsentsView />} />
				<Route path="/consents/add" element={<ConsentsAdd />} />
				<Route path="/consents/edit/:pageid" element={<ConsentsEdit />} />

				{/* contacts pages routes */}
				<Route path="/contacts" element={<ContactsList />} />
				<Route path="/contacts/:fieldName/:fieldValue" element={<ContactsList />} />
				<Route path="/contacts/index/:fieldName/:fieldValue" element={<ContactsList />} />
				<Route path="/contacts/view/:pageid" element={<ContactsView />} />
				<Route path="/contacts/add" element={<ContactsAdd />} />
				<Route path="/contacts/edit/:pageid" element={<ContactsEdit />} />

				{/* customernotifications pages routes */}
				<Route path="/customernotifications" element={<CustomernotificationsList />} />
				<Route path="/customernotifications/:fieldName/:fieldValue" element={<CustomernotificationsList />} />
				<Route path="/customernotifications/index/:fieldName/:fieldValue" element={<CustomernotificationsList />} />
				<Route path="/customernotifications/view/:pageid" element={<CustomernotificationsView />} />
				<Route path="/customernotifications/add" element={<CustomernotificationsAdd />} />
				<Route path="/customernotifications/edit/:pageid" element={<CustomernotificationsEdit />} />
				<Route path="/customernotifications/notify" element={<CustomernotificationsNotify />} />
				<Route path="/customernotifications/notify/:fieldName/:fieldValue" element={<CustomernotificationsNotify />} />

				{/* inventory pages routes */}
				<Route path="/inventory" element={<InventoryList />} />
				<Route path="/inventory/:fieldName/:fieldValue" element={<InventoryList />} />
				<Route path="/inventory/index/:fieldName/:fieldValue" element={<InventoryList />} />
				<Route path="/inventory/view/:pageid" element={<InventoryView />} />
				<Route path="/inventory/add" element={<InventoryAdd />} />
				<Route path="/inventory/edit/:pageid" element={<InventoryEdit />} />

				{/* itemtypes pages routes */}
				<Route path="/itemtypes" element={<ItemtypesList />} />
				<Route path="/itemtypes/:fieldName/:fieldValue" element={<ItemtypesList />} />
				<Route path="/itemtypes/index/:fieldName/:fieldValue" element={<ItemtypesList />} />
				<Route path="/itemtypes/view/:pageid" element={<ItemtypesView />} />
				<Route path="/itemtypes/add" element={<ItemtypesAdd />} />
				<Route path="/itemtypes/edit/:pageid" element={<ItemtypesEdit />} />

				{/* itemtypetreatments pages routes */}
				<Route path="/itemtypetreatments" element={<ItemtypetreatmentsList />} />
				<Route path="/itemtypetreatments/:fieldName/:fieldValue" element={<ItemtypetreatmentsList />} />
				<Route path="/itemtypetreatments/index/:fieldName/:fieldValue" element={<ItemtypetreatmentsList />} />
				<Route path="/itemtypetreatments/view/:pageid" element={<ItemtypetreatmentsView />} />
				<Route path="/itemtypetreatments/add" element={<ItemtypetreatmentsAdd />} />
				<Route path="/itemtypetreatments/edit/:pageid" element={<ItemtypetreatmentsEdit />} />
				<Route path="/itemtypetreatments/treatement_partner" element={<ItemtypetreatmentsTreatementpartner />} />
				<Route path="/itemtypetreatments/treatement_partner/:fieldName/:fieldValue" element={<ItemtypetreatmentsTreatementpartner />} />

				{/* notifications pages routes */}
				<Route path="/notifications" element={<NotificationsList />} />
				<Route path="/notifications/:fieldName/:fieldValue" element={<NotificationsList />} />
				<Route path="/notifications/index/:fieldName/:fieldValue" element={<NotificationsList />} />
				<Route path="/notifications/view/:pageid" element={<NotificationsView />} />
				<Route path="/notifications/add" element={<NotificationsAdd />} />
				<Route path="/notifications/edit/:pageid" element={<NotificationsEdit />} />

				{/* orderitems pages routes */}
				<Route path="/orderitems" element={<OrderitemsList />} />
				<Route path="/orderitems/:fieldName/:fieldValue" element={<OrderitemsList />} />
				<Route path="/orderitems/index/:fieldName/:fieldValue" element={<OrderitemsList />} />
				<Route path="/orderitems/view/:pageid" element={<OrderitemsView />} />
				<Route path="/orderitems/add" element={<OrderitemsAdd />} />
				<Route path="/orderitems/edit/:pageid" element={<OrderitemsEdit />} />
				<Route path="/orderitems/listordcustomer" element={<OrderitemsListordcustomer />} />
				<Route path="/orderitems/listordcustomer/:fieldName/:fieldValue" element={<OrderitemsListordcustomer />} />

				{/* partnerdocuments pages routes */}
				<Route path="/partnerdocuments" element={<PartnerdocumentsList />} />
				<Route path="/partnerdocuments/:fieldName/:fieldValue" element={<PartnerdocumentsList />} />
				<Route path="/partnerdocuments/index/:fieldName/:fieldValue" element={<PartnerdocumentsList />} />
				<Route path="/partnerdocuments/view/:pageid" element={<PartnerdocumentsView />} />
				<Route path="/partnerdocuments/add" element={<PartnerdocumentsAdd />} />
				<Route path="/partnerdocuments/edit/:pageid" element={<PartnerdocumentsEdit />} />

				{/* partnernotifications pages routes */}
				<Route path="/partnernotifications" element={<PartnernotificationsList />} />
				<Route path="/partnernotifications/:fieldName/:fieldValue" element={<PartnernotificationsList />} />
				<Route path="/partnernotifications/index/:fieldName/:fieldValue" element={<PartnernotificationsList />} />
				<Route path="/partnernotifications/view/:pageid" element={<PartnernotificationsView />} />
				<Route path="/partnernotifications/add" element={<PartnernotificationsAdd />} />
				<Route path="/partnernotifications/edit/:pageid" element={<PartnernotificationsEdit />} />

				{/* partnerpayments pages routes */}
				<Route path="/partnerpayments" element={<PartnerpaymentsList />} />
				<Route path="/partnerpayments/:fieldName/:fieldValue" element={<PartnerpaymentsList />} />
				<Route path="/partnerpayments/index/:fieldName/:fieldValue" element={<PartnerpaymentsList />} />
				<Route path="/partnerpayments/view/:pageid" element={<PartnerpaymentsView />} />
				<Route path="/partnerpayments/add" element={<PartnerpaymentsAdd />} />
				<Route path="/partnerpayments/edit/:pageid" element={<PartnerpaymentsEdit />} />

				{/* partnerpaymentvw pages routes */}
				<Route path="/partnerpaymentvw" element={<PartnerpaymentvwList />} />
				<Route path="/partnerpaymentvw/:fieldName/:fieldValue" element={<PartnerpaymentvwList />} />
				<Route path="/partnerpaymentvw/index/:fieldName/:fieldValue" element={<PartnerpaymentvwList />} />

				{/* partnerperformance pages routes */}
				<Route path="/partnerperformance" element={<PartnerperformanceList />} />
				<Route path="/partnerperformance/:fieldName/:fieldValue" element={<PartnerperformanceList />} />
				<Route path="/partnerperformance/index/:fieldName/:fieldValue" element={<PartnerperformanceList />} />
				<Route path="/partnerperformance/view/:pageid" element={<PartnerperformanceView />} />
				<Route path="/partnerperformance/add" element={<PartnerperformanceAdd />} />
				<Route path="/partnerperformance/edit/:pageid" element={<PartnerperformanceEdit />} />

				{/* partnerreviews pages routes */}
				<Route path="/partnerreviews" element={<PartnerreviewsList />} />
				<Route path="/partnerreviews/:fieldName/:fieldValue" element={<PartnerreviewsList />} />
				<Route path="/partnerreviews/index/:fieldName/:fieldValue" element={<PartnerreviewsList />} />
				<Route path="/partnerreviews/view/:pageid" element={<PartnerreviewsView />} />
				<Route path="/partnerreviews/add" element={<PartnerreviewsAdd />} />
				<Route path="/partnerreviews/edit/:pageid" element={<PartnerreviewsEdit />} />

				{/* partnershops pages routes */}
				<Route path="/partnershops" element={<PartnershopsList />} />
				<Route path="/partnershops/:fieldName/:fieldValue" element={<PartnershopsList />} />
				<Route path="/partnershops/index/:fieldName/:fieldValue" element={<PartnershopsList />} />
				<Route path="/partnershops/view/:pageid" element={<PartnershopsView />} />
				<Route path="/partnershops/add" element={<PartnershopsAdd />} />
				<Route path="/partnershops/edit/:pageid" element={<PartnershopsEdit />} />
				<Route path="/partnershops/partner" element={<PartnershopsPartner />} />
				<Route path="/partnershops/partner/:fieldName/:fieldValue" element={<PartnershopsPartner />} />

				{/* payments pages routes */}
				<Route path="/payments" element={<PaymentsList />} />
				<Route path="/payments/:fieldName/:fieldValue" element={<PaymentsList />} />
				<Route path="/payments/index/:fieldName/:fieldValue" element={<PaymentsList />} />
				<Route path="/payments/view/:pageid" element={<PaymentsView />} />
				<Route path="/payments/add" element={<PaymentsAdd />} />
				<Route path="/payments/edit/:pageid" element={<PaymentsEdit />} />
				<Route path="/payments/paymentcustomer" element={<PaymentsPaymentcustomer />} />
				<Route path="/payments/paymentcustomer/:fieldName/:fieldValue" element={<PaymentsPaymentcustomer />} />

				{/* permissions pages routes */}
				<Route path="/permissions" element={<PermissionsList />} />
				<Route path="/permissions/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/index/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/view/:pageid" element={<PermissionsView />} />
				<Route path="/permissions/add" element={<PermissionsAdd />} />
				<Route path="/permissions/edit/:pageid" element={<PermissionsEdit />} />

				{/* promotions pages routes */}
				<Route path="/promotions" element={<PromotionsList />} />
				<Route path="/promotions/:fieldName/:fieldValue" element={<PromotionsList />} />
				<Route path="/promotions/index/:fieldName/:fieldValue" element={<PromotionsList />} />
				<Route path="/promotions/view/:pageid" element={<PromotionsView />} />
				<Route path="/promotions/add" element={<PromotionsAdd />} />
				<Route path="/promotions/edit/:pageid" element={<PromotionsEdit />} />

				{/* roles pages routes */}
				<Route path="/roles" element={<RolesList />} />
				<Route path="/roles/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/index/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/view/:pageid" element={<RolesView />} />
				<Route path="/roles/add" element={<RolesAdd />} />
				<Route path="/roles/edit/:pageid" element={<RolesEdit />} />

				{/* serviceprices pages routes */}
				<Route path="/serviceprices" element={<ServicepricesList />} />
				<Route path="/serviceprices/:fieldName/:fieldValue" element={<ServicepricesList />} />
				<Route path="/serviceprices/index/:fieldName/:fieldValue" element={<ServicepricesList />} />
				<Route path="/serviceprices/view/:pageid" element={<ServicepricesView />} />
				<Route path="/serviceprices/add" element={<ServicepricesAdd />} />
				<Route path="/serviceprices/edit/:pageid" element={<ServicepricesEdit />} />

				{/* services pages routes */}
				<Route path="/services" element={<ServicesList />} />
				<Route path="/services/:fieldName/:fieldValue" element={<ServicesList />} />
				<Route path="/services/index/:fieldName/:fieldValue" element={<ServicesList />} />
				<Route path="/services/view/:pageid" element={<ServicesView />} />
				<Route path="/services/add" element={<ServicesAdd />} />
				<Route path="/services/edit/:pageid" element={<ServicesEdit />} />

				{/* settings pages routes */}
				<Route path="/settings" element={<SettingsList />} />
				<Route path="/settings/:fieldName/:fieldValue" element={<SettingsList />} />
				<Route path="/settings/index/:fieldName/:fieldValue" element={<SettingsList />} />
				<Route path="/settings/view/:pageid" element={<SettingsView />} />
				<Route path="/settings/add" element={<SettingsAdd />} />
				<Route path="/settings/edit/:pageid" element={<SettingsEdit />} />

				{/* staff pages routes */}
				<Route path="/staff" element={<StaffList />} />
				<Route path="/staff/:fieldName/:fieldValue" element={<StaffList />} />
				<Route path="/staff/index/:fieldName/:fieldValue" element={<StaffList />} />
				<Route path="/staff/view/:pageid" element={<StaffView />} />
				<Route path="/staff/add" element={<StaffAdd />} />
				<Route path="/staff/edit/:pageid" element={<StaffEdit />} />
				<Route path="/staff/partner" element={<StaffPartner />} />
				<Route path="/staff/partner/:fieldName/:fieldValue" element={<StaffPartner />} />

				{/* staffassignments pages routes */}
				<Route path="/staffassignments" element={<StaffassignmentsList />} />
				<Route path="/staffassignments/:fieldName/:fieldValue" element={<StaffassignmentsList />} />
				<Route path="/staffassignments/index/:fieldName/:fieldValue" element={<StaffassignmentsList />} />
				<Route path="/staffassignments/view/:pageid" element={<StaffassignmentsView />} />
				<Route path="/staffassignments/add" element={<StaffassignmentsAdd />} />
				<Route path="/staffassignments/edit/:pageid" element={<StaffassignmentsEdit />} />

				{/* staffassingmentvw pages routes */}
				<Route path="/staffassingmentvw" element={<StaffassingmentvwList />} />
				<Route path="/staffassingmentvw/:fieldName/:fieldValue" element={<StaffassingmentvwList />} />
				<Route path="/staffassingmentvw/index/:fieldName/:fieldValue" element={<StaffassingmentvwList />} />

				{/* staffvw pages routes */}
				<Route path="/staffvw" element={<StaffvwList />} />
				<Route path="/staffvw/:fieldName/:fieldValue" element={<StaffvwList />} />
				<Route path="/staffvw/index/:fieldName/:fieldValue" element={<StaffvwList />} />
				<Route path="/staffvw/view/:pageid" element={<StaffvwView />} />

				{/* states pages routes */}
				<Route path="/states" element={<StatesList />} />
				<Route path="/states/:fieldName/:fieldValue" element={<StatesList />} />
				<Route path="/states/index/:fieldName/:fieldValue" element={<StatesList />} />
				<Route path="/states/view/:pageid" element={<StatesView />} />
				<Route path="/states/add" element={<StatesAdd />} />
				<Route path="/states/edit/:pageid" element={<StatesEdit />} />

				{/* treatments pages routes */}
				<Route path="/treatments" element={<TreatmentsList />} />
				<Route path="/treatments/:fieldName/:fieldValue" element={<TreatmentsList />} />
				<Route path="/treatments/index/:fieldName/:fieldValue" element={<TreatmentsList />} />
				<Route path="/treatments/view/:pageid" element={<TreatmentsView />} />
				<Route path="/treatments/add" element={<TreatmentsAdd />} />
				<Route path="/treatments/edit/:pageid" element={<TreatmentsEdit />} />

				{/* users pages routes */}
				<Route path="/users" element={<UsersList />} />
				<Route path="/users/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/index/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/view/:pageid" element={<UsersView />} />
				<Route path="/users/add" element={<UsersAdd />} />
				<Route path="/users/edit/:pageid" element={<UsersEdit />} />
				<Route path="/users/partnerreister" element={<UsersPartnerreister />} />

				{/* vwactivebookings pages routes */}
				<Route path="/vwactivebookings" element={<VwactivebookingsList />} />
				<Route path="/vwactivebookings/:fieldName/:fieldValue" element={<VwactivebookingsList />} />
				<Route path="/vwactivebookings/index/:fieldName/:fieldValue" element={<VwactivebookingsList />} />

				{/* vwcustomerlifetimevalue pages routes */}
				<Route path="/vwcustomerlifetimevalue" element={<VwcustomerlifetimevalueList />} />
				<Route path="/vwcustomerlifetimevalue/:fieldName/:fieldValue" element={<VwcustomerlifetimevalueList />} />
				<Route path="/vwcustomerlifetimevalue/index/:fieldName/:fieldValue" element={<VwcustomerlifetimevalueList />} />

				{/* vwdailybookingsummary pages routes */}
				<Route path="/vwdailybookingsummary" element={<VwdailybookingsummaryList />} />
				<Route path="/vwdailybookingsummary/:fieldName/:fieldValue" element={<VwdailybookingsummaryList />} />
				<Route path="/vwdailybookingsummary/index/:fieldName/:fieldValue" element={<VwdailybookingsummaryList />} />

				{/* vwinventorystatus pages routes */}
				<Route path="/vwinventorystatus" element={<VwinventorystatusList />} />
				<Route path="/vwinventorystatus/:fieldName/:fieldValue" element={<VwinventorystatusList />} />
				<Route path="/vwinventorystatus/index/:fieldName/:fieldValue" element={<VwinventorystatusList />} />

				{/* vwmonthlyperformance pages routes */}
				<Route path="/vwmonthlyperformance" element={<VwmonthlyperformanceList />} />
				<Route path="/vwmonthlyperformance/:fieldName/:fieldValue" element={<VwmonthlyperformanceList />} />
				<Route path="/vwmonthlyperformance/index/:fieldName/:fieldValue" element={<VwmonthlyperformanceList />} />

				{/* vwpendingpayments pages routes */}
				<Route path="/vwpendingpayments" element={<VwpendingpaymentsList />} />
				<Route path="/vwpendingpayments/:fieldName/:fieldValue" element={<VwpendingpaymentsList />} />
				<Route path="/vwpendingpayments/index/:fieldName/:fieldValue" element={<VwpendingpaymentsList />} />

				{/* vwserviceperformance pages routes */}
				<Route path="/vwserviceperformance" element={<VwserviceperformanceList />} />
				<Route path="/vwserviceperformance/:fieldName/:fieldValue" element={<VwserviceperformanceList />} />
				<Route path="/vwserviceperformance/index/:fieldName/:fieldValue" element={<VwserviceperformanceList />} />

				{/* vwstaffperformance pages routes */}
				<Route path="/vwstaffperformance" element={<VwstaffperformanceList />} />
				<Route path="/vwstaffperformance/:fieldName/:fieldValue" element={<VwstaffperformanceList />} />
				<Route path="/vwstaffperformance/index/:fieldName/:fieldValue" element={<VwstaffperformanceList />} />

				{/* wallettransaction pages routes */}
				<Route path="/wallettransaction" element={<WallettransactionList />} />
				<Route path="/wallettransaction/:fieldName/:fieldValue" element={<WallettransactionList />} />
				<Route path="/wallettransaction/index/:fieldName/:fieldValue" element={<WallettransactionList />} />
				<Route path="/wallettransaction/view/:pageid" element={<WallettransactionView />} />
				<Route path="/wallettransaction/add" element={<WallettransactionAdd />} />
				<Route path="/wallettransaction/edit/:pageid" element={<WallettransactionEdit />} />
				<Route path="/wallettransaction/partner_wallet" element={<WallettransactionPartnerwallet />} />
				<Route path="/wallettransaction/partner_wallet/:fieldName/:fieldValue" element={<WallettransactionPartnerwallet />} />

				{/* walletvw pages routes */}
				<Route path="/walletvw" element={<WalletvwList />} />
				<Route path="/walletvw/:fieldName/:fieldValue" element={<WalletvwList />} />
				<Route path="/walletvw/index/:fieldName/:fieldValue" element={<WalletvwList />} />

				{/* webhooklogs pages routes */}
				<Route path="/webhooklogs" element={<WebhooklogsList />} />
				<Route path="/webhooklogs/:fieldName/:fieldValue" element={<WebhooklogsList />} />
				<Route path="/webhooklogs/index/:fieldName/:fieldValue" element={<WebhooklogsList />} />
				<Route path="/webhooklogs/view/:pageid" element={<WebhooklogsView />} />
				<Route path="/webhooklogs/add" element={<WebhooklogsAdd />} />
				<Route path="/webhooklogs/edit/:pageid" element={<WebhooklogsEdit />} />
				<Route path="/quickbookingwidget" element={<QuickbookingwidgetPage />} />
				<Route path="/bookingquick" element={<BookingquickPage />} />
				<Route path="/customer" element={<CustomerPage />} />
				<Route path="/staff" element={<StaffPage />} />
				<Route path="/partner" element={<PartnerPage />} />
				<Route path="/paymentdue" element={<PaymentduePage />} />
				<Route path="/additems" element={<AdditemsPage />} />
				<Route path="/bcalender" element={<BcalenderPage />} />
				<Route path="/staffcalendar" element={<StaffcalendarPage />} />
				<Route path="/printinvoice" element={<PrintinvoicePage />} />
				<Route path="/customerreview" element={<CustomerreviewPage />} />
				<Route path="/topupwallet" element={<TopupwalletPage />} />
				<Route path="/whatsappchat" element={<WhatsappchatPage />} />
				<Route path="/additional_item" element={<AdditionalItemPage />} />
				<Route path="/pricecompare" element={<PricecomparePage />} />
				<Route path="/account/*" element={<AccountPages />} />
			</Route>
			</Route>
			<Route exact element={<IndexLayout />}>
				<Route path="/" element={<DefaultPage />} />
				<Route path="/*" element={<IndexPages />} />
				<Route path="/error/*" element={<ErrorPages />} />
				<Route path="/consent" element={<ConsentPage />} />
				<Route path="/topup-success" element={<TopupSuccess />} />
				<Route path="/partnerreister" element={<UsersPartnerreister />} />
				<Route path="/track/:orderId" element={<OrderStatusFlow />} />


			</Route>
		</Routes>
	);
}
export default App;
